import React, { Component } from "react";

import * as styles from "./Total.scss";

export interface ITotalProps {
    label?: string;
    children?: React.ReactNode;
}

export class Total extends Component<ITotalProps> {
    public render() {
        const { children, label } = this.props;

        return (
            <div className={styles.total}>
                <div className={styles.children}>{children}</div>
                {label && <div className={styles.label}>{label}</div>}
            </div>
        );
    }
}
